// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2krBD","label":"styles_label__1xSBv"};